import React from 'react';
import { Link } from 'react-router-dom';
import './PageNotFound.css';

const PageNotFound: React.FC = () => {
  return (
    <div className="page-not-found">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2>Page Not Found</h2>
        <p className="text-muted">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/dashboard/transaction-dashboard" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
